<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #SHOWSTATUS>
      <order-tracker v-if="statusId" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getAnalysis, getDetails, exportAnalysis } from "@/api/analysis/list";
import { getCountry } from "@/api/system/country";
import { getCity } from "@/api/system/city";
import { getSelectType } from "@/api/public";
import { getUser } from "@/api/user/internal";
import { getChannel } from "@/api/tracker/channel";
import { getAgent } from "@/api/tracker/agent";
import { getStatus } from "@/api/tracker/status";
import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/order_tracker";
import { getCustomerGroup } from "@/api/analysis/orderStatusList";
import cTable from "@/base/common/index";
// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "timesList",
  components: {
    cTable,
    orderTracker,
  },
  data() {
    return {
      statusId: "",
      methods: {
        list(p) {
          if (p.deliver) p.deliver = p.deliver.join(",");
          return getAnalysis(p);
        },
        // list: getAnalysis,
        getDetails,
        getCountry,
        getAgent,
        getAllClient,
        getChannel,
        exportAnalysis,
        getSelectType,
        //  afterHandleList() {
        //   this.getTable().toggleRowExpand(this.list[0]);
        // }
      },
      config: {
        height: 630,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [
            { title: 24 },
            { code: 24 },
            { zipcode: 24 },
            { country_id: 24 },
            { status: 24 },
            { remote_regions: 24 },
          ],
          fields: [
            {
              name: () => this.$t("city_name"),
              key: "title",
              component: "Input",
              bind: {
                placeholder: "Enter Name",
              },
            },
            {
              name: () => this.$t("city_code"),
              key: "code",
              component: "Input",
              bind: {
                placeholder: "Enter Code",
              },
            },
            {
              name: () => this.$t("zip_code"),
              key: "zipcode",
              component: "Input",
              bind: {
                placeholder: "Enter zipcode",
              },
            },
            {
              name: () => this.$t("countryName"),
              key: "country_id",
              component: "Select",
              bind: {
                placeholder: this.$t("select") + this.$t("countryName"),
              },
              options: [],
              config: { label: "title", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry")
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },

            {
              name: () => this.$t("exlType"),
              key: "status",
              placeholder() {
                return this.$t("select") + this.$t("exlType");
              },
              component: "Radio",
              options: [
                { label: this.$t("enable"), value: "ENABLE" },
                { label: this.$t("disable"), value: "DISABLE" },
              ],
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("remote_regions"),
              key: "remote_regions",
              component: "Radio",
              placeholder() {
                return this.$t("select") + this.$t("remote_regions");
              },
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 },
              ],
              bind: {
                border: true,
              },
            },
          ],
        },
        showstatus: {
          contentSlot: "SHOWSTATUS",
          methods: {
            cancel: ({ close }) => {
              this.statusId = "";
            },
          },
          footer: {
            show: false,
          },
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType("ANALYZE_DATE_SELECT")).data
                  .payload["ANALYZE_DATE_SELECT"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   newFormData.temp = 1;
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   newFormData.temp = 1;
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            key: "types",
            placeholder() {
              return this.$tz("订单类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            bind: {
              multiple: true,
            },
            optionsKey: "ORDERS_TYPE",
          },
          {
            key: "fromCountry",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "toCountry",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
            methods: {
              async "on-change"({ value, field, fields, searchForm }) {
                let country = field.options.find((t) => t.code === value);
                fields.forEach(async (el) => {
                  if (el.key == "city_name") {
                    if (country) {
                      let res = (await getCity({ country_id: country.id })).data
                        .payload.rows;
                      el.options = res;
                    } else {
                      el.options = [];
                    }
                    searchForm[el.key] = "";
                    return;
                  }
                });
              },
            },
          },
          {
            key: "city_name",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("city_name");
            },
            clearable: true,
            options: [],
            config: {
              label: "title",
              value: "title",
            },
          },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "group_name",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("customer_group");
            },
            options: [],
            config: { label: "group_name", value: "group_name" },
          },
          {
            key: "clientId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "channelCode",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("channel_name");
            },
            clearable: true,
            options: [],
            config: {
              label({ row }) {
                return row.channel_name + "-" + row.channel_code;
              },
              value: "channel_code",
            },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "codType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("cod_type");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            methods: {
              async list({ field, searchForm }) {
                field.options = await this.$sel.getData("COD_TYPE");
                this.$forceUpdate();
              },
            },
          },
          {
            key: "deliver",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("localFaction");
            },
            clearable: true,
            options: [],
            default: [],
            config: { label: "agent_name", value: "agent_name" },
            bind: {
              style: "width:140px",
              multiple: true,
              "max-tag-count": 5,
            },
          },
          {
            key: "noUpdateDay",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("not_update_time");
            },
            clearable: true,
            options: [],
            // config: { label: "agent_name", value: "agent_name" },
            bind: {
              style: "width:140px",
            },
          },

          {
            key: "trackerStatus",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("tracker_code");
            },
            clearable: true,
            options: [],
            config: { label: "tracker_code", value: "tracker_code" },
            bind: {
              style: "width:140px",
            },
          },
          {
            key: "delivery_agent",
            placeholder() {
              return this.$tz("派送商");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            bind: {
              multiple: true,
              "max-tag-count": 3,
            },
            config: { label: "agent_name", value: "agent_name" },
          },
          {
            key: "circuit_id",
            placeholder() {
              return this.$tz("派送线路");
            },
            component: "Select",
            options: [],
            optionsFn: "getCircuit",
            optionsKey: "",
          },
          {
            key: "headerType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("is_goods") + this.$t("type");
            },
            clearable: true,
            options: [],
            // config: { label: "tracker_code", value: "tracker_code" },
            bind: {
              style: "width:140px",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("analysis1"),
              type: "add",
              fnName: "add",
              bind: {
                type: "warning",
              },
            },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              let searchForm = this.$refs["header"].handleFilterData();
              if (searchForm.date && searchForm.date.length == 0) {
                this.$Message["error"]({
                  background: true,
                  content:
                    this.$t("select") +
                    this.$t("warehouse_in_out") +
                    this.$t("time"),
                });
              }
              if (!searchForm.dateType) {
                this.$Message["error"]({
                  background: true,
                  content: this.$t("select") + this.$t("timeType"),
                });
                return;
              }
              let data = JSON.parse(JSON.stringify(searchForm));
              if (data.deliver) data.deliver = data.deliver.join(",");
              delete data.page;
              delete data.pageSize;
              delete data.date;
              this.$Modal.confirm({
                title: this.$t("analysis1"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("exportAnalysis", data).then(() => {
                    this.$Message["success"]({
                      background: true,
                      content: this.$t("result_see"),
                    });
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          align: "center",
          minWidth: 180,
          tooltip: false,
          header: {
            copy: true, //头部复制
          },
          copy: true,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render: ({ value }) => {
              return value;
            },
            click({ row }) {
              // console.log("this", this);
              this.$page.$parent.statusId = row.airway_number;
              this.$page
                .getModal("showstatus")
                .setTitle(
                  row.airway_number + "(+" + this.$t("trajectory") + ")"
                );
              this.$page.getModal("showstatus").open(row.airway_number);
            },
          },
          // render: (h, { row }) => {
          //   return h(
          //     "Button",
          //     {
          //       props: {
          //         type: "primary",
          //         size: "small"
          //       },
          //       on: {
          //         click: () => {
          //           // this.crudClick(row);
          //           this.statusId = row.airway_number;
          //           console.log("this", this);
          //           return false;
          //           this.$refs["showSatus"].open(row.airway_number);
          //         }
          //       }
          //     },
          //     row.airway_number
          //   );
          // }
        },
        {
          name: () => this.$t("localFaction"),
          key: "deliver",
          align: "center",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("outbound_time"),
          align: "center",
          key: "outbound_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          align: "center",
          width: 95,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          width: 95,
        },
        {
          name: () => this.$tz("城市名称"),
          key: "city_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("起运机场"),
          key: "from_port",
          minWidth: 110,
        },
        {
          name: () => this.$tz("目的机场"),
          key: "to_port",
          minWidth: 110,
        },
        {
          name: () => this.$t("channel_code"),
          align: "center",
          key: "channel_code",
          width: 95,
        },
        {
          name: () => this.$t("serviceAccount"),
          align: "center",
          key: "service_name",
          width: 95,
          tooltip: true,
        },

        {
          name: () => this.$t("clientName"),
          align: "center",
          key: "client_name",
          width: 95,
          tooltip: true,
        },
        {
          name: () => this.$t("派送商"),
          align: "center",
          key: "delivery_agent",
          width: 95,
        },
        {
          name: () => this.$t("cod_type"),
          align: "center",
          key: "cod_type",
          width: 95,
        },
        {
          name: () => this.$t("cod_amount"),
          align: "center",
          key: "cod_amount",
          width: 95,
        },
        {
          name: () => this.$t("warehouse_time"),
          align: "center",
          key: "arrival_warehouse",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$tz("到港"),
          key: "to_port_time",
          minWidth: 110,
        },
        {
          name: () => this.$t("residence_time"),
          align: "center",
          key: "residence_time",
          width: 95,
        },
        {
          name: () => this.$t("flight_time"),
          align: "center",
          key: "flight_time",
          width: 95,
        },
        {
          name: () => this.$t("clearance_time"),
          align: "center",
          key: "clearance_time",
          width: 95,
        },
        {
          name: () => this.$t("arrival_time"),
          align: "center",
          key: "arrival_time",
          width: 95,
        },
        {
          name: () => this.$t("first_140_time"),
          align: "center",
          key: "first_140_time",
          width: 95,
        },
        {
          name: () => this.$t("first_140"),
          align: "center",
          key: "first_140",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("first_refuse_time"),
          align: "center",
          key: "first_refuse_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$tz('首派,结果,时间'),
          key: 'first_result_time',
          minWidth: 110,
        },
        {
          name: () => this.$t("first_delivery_remarks"),
          align: "center",
          key: "first_delivery_remarks",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("second_140_time"),
          align: "center",
          key: "second_140_time",
          width: 95,
        },
        {
          name: () => this.$t("second_140"),
          align: "center",
          key: "second_140",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("second_refuse_time"),
          align: "center",
          key: "second_refuse_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("second_delivery_remarks"),
          align: "center",
          key: "second_delivery_remarks",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("third_140_time"),
          align: "center",
          key: "third_140_time",
          width: 95,
        },
        {
          name: () => this.$t("third_140"),
          align: "center",
          key: "third_140",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("third_refuse_time"),
          align: "center",
          key: "third_refuse_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("third_delivery_remarks"),
          align: "center",
          key: "third_delivery_remarks",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("fourth_140_time"),
          align: "center",
          key: "four_140_time",
          width: 95,
        },
        {
          name: () => this.$t("fourth_140"),
          align: "center",
          key: "four_140",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("fourth_refuse_time"),
          align: "center",
          key: "four_refuse_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("fourth_delivery_remarks"),
          align: "center",
          key: "four_delivery_remarks",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("fifth_140_time"),
          align: "center",
          key: "fives_140_time",
          width: 95,
        },
        {
          name: () => this.$t("fifth_140"),
          align: "center",
          key: "fives_140",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("fifth_refuse_time"),
          align: "center",
          key: "fives_refuse_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("fifth_delivery_remarks"),
          align: "center",
          key: "fives_delivery_remarks",
          width: 130,
          tooltip: true,
        },
        {
          name: () => "Transfer out 1",
          align: "center",
          key: "first_out_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => "Transfer in 1",
          align: "center",
          key: "first_enter_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => "Transfer out 2",
          align: "center",
          key: "second_out_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => "Transfer in 2",
          align: "center",
          key: "second_enter_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => "Transfer out 3",
          align: "center",
          key: "third_out_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => "Transfer in 3",
          align: "center",
          key: "third_enter_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("latest_delivery_time"),
          align: "center",
          key: "success_delivery_time",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("latest_delivery_remarks"),
          align: "center",
          key: "new_delivery_remarks",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("c_pod"),
          align: "center",
          key: "c_pod",
          width: 110,
        },
        {
          name: () => this.$t("finish_time"),
          align: "center",
          key: "finish_time",
          width: 110,
        },
        {
          name: () => this.$t("time_in_transit"),
          align: "center",
          key: "time_in_transit",
          width: 95,
        },
        {
          name: () => this.$t("retired_times"),
          align: "center",
          key: "delivery_number",
          width: 95,
        },
        {
          name: () => this.$t("called_times"),
          align: "center",
          key: "miss_contact_time",
          width: 110,
        },
        {
          name: () => this.$t("refuse_number"),
          align: "center",
          key: "refuse_number",
          width: 95,
        },
        {
          name: () => this.$t("Intercept Count"),
          align: "center",
          key: "LJ_number",
          width: 95,
        },
        {
          name: () => this.$t("not_update_time"),
          align: "center",
          key: "not_update_time",
          width: 95,
        },
        {
          name: () => this.$t("tracker_code"),
          align: "center",
          key: "trackerStatus",
          width: 90,
        },
        {
          name: () => this.$t("tracker_description"),
          align: "center",
          key: "status_remarks",
          width: 110,
        },
        {
          name: () => this.$t("new_tracker_time"),
          align: "center",
          key: "status_time",
          width: 130,
        },
        {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          minWidth: 110,
        },
        // {
        //   name: () => this.$t("tracker_description_cn"),
        //   key: "status_cn",
        //   minWidth: 100
        // }
      ],
    };
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "clientId")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
      if (item.key === "toCountry" || item.key === "fromCountry")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "channelCode")
        item.options = (await getChannel()).data.payload.rows;
      if (item.key === "deliver" || item.key === "delivery_agent")
        item.options = (
          await getAgent({
            agent_type: "bag",
            status: "YES",
            types: "DELIVERY",
          })
        ).data.payload.rows;
      if (item.key === "noUpdateDay")
        item.options = (
          await getSelectType(["ANALYZE_SELECT_DAY"])
        ).data.payload["ANALYZE_SELECT_DAY"];
      if (item.key === "headerType")
        item.options = (
          await getSelectType("OUTBOUND_SELECT_TYPE")
        ).data.payload["OUTBOUND_SELECT_TYPE"];
      if (item.key === "trackerStatus")
        item.options = (await getStatus({ pageSize: 9999 })).data.payload.rows;
      if (item.key === "group_name")
        item.options = (await getCustomerGroup()).data.payload.rows;
    });
  },
};
</script>
